import React from 'react'
import BrotherList from '../../components/Brother/BrotherList'
import Header from '../../components/Header'

const Brother = () => {
  return (
    <div>
        <Header />
        <BrotherList />
    </div>
  )
}

export default Brother